import moment from 'moment';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';

/**
 * Get page limit from user preferences based on context
 * @param {boolean} isLeadSpecific - Whether this is from lead-specific module
 * @param {boolean} isFromCaseSpecificModule - Whether this is from case-specific module
 * @param {Object} userContext - User context object
 * @returns {number|undefined} Page limit or undefined
 */
export const getPageLimit = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return userContext?.firmDetails?.pagination_preference?.leads?.billings?.trust_accounting;
  } else if (isFromCaseSpecificModule && userContext) {
    return userContext?.firmDetails?.pagination_preference?.case?.trust_list;
  } else if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.trust_accounting;
  }
  return undefined;
};

/**
 * Get file path for pagination preferences
 * @param {boolean} isLeadSpecific - Whether this is from lead-specific module
 * @param {boolean} isFromCaseSpecificModule - Whether this is from case-specific module
 * @param {Object} userContext - User context object
 * @returns {Object} Path object with module, subModule, and listName
 */
export const getFilePathForPagination = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return { module: 'leads', subModule: 'billings', listName: 'trust_accounting' };
  } else if (isFromCaseSpecificModule && userContext) {
    return { module: 'case', subModule: '', listName: 'trust_list' };
  } else {
    return { module: 'billings', subModule: '', listName: 'trust_accounting' };
  }
};

/**
 * Extract date range from calendar selection and convert to timezone format
 * @param {Array} dateArray - Array of dates from calendar [startDate, endDate]
 * @param {string} timezone - User's timezone
 * @returns {Object} Object with transaction_date_lower and transaction_date_upper
 */
export const pickExtractedDate = (dateArray, timezone) => {
  return {
    transaction_date_lower: dateArray?.[0] ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), timezone) : '',
    transaction_date_upper: dateArray?.[0]
      ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), timezone)
      : '',
  };
};
